@if (showComponent) {
  <div (click)="toggleExpanded()" class="collapsable" data-cy="side-bar-menu-collapse-button">
    <app-tooltip [message]="getTooltipText()" [dynamic]="false" placement="right">
      <div class="collapse-button">
        <span data-cy="side-menu-collapse-button-icon"
          [ngClass]="{'iwp-icon-gen_nav_arrow_right': !isExpanded, 'iwp-icon-gen_nav_arrow_left': isExpanded}"
        class="icon"></span>
      </div>
    </app-tooltip>
  </div>
  @if (isExpanded) {
    @if (menuItems) {
      <app-side-bar-menu-item [menuItems]="menuItems"></app-side-bar-menu-item>
    }
  }
  @if (!isExpanded) {
    @if (menuItemsCollapsed) {
      <app-side-bar-menu-item-collapsed
      [menuItems]="menuItemsCollapsed"></app-side-bar-menu-item-collapsed>
    }
  }
}
